import logInDevMode from './logInDevMode';

export default logInDevMode;
